import { render, staticRenderFns } from "./LabelComparator.vue?vue&type=template&id=6fb65fd4&scoped=true&"
import script from "./LabelComparator.vue?vue&type=script&lang=ts&"
export * from "./LabelComparator.vue?vue&type=script&lang=ts&"
import style0 from "./LabelComparator.vue?vue&type=style&index=0&id=6fb65fd4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb65fd4",
  null
  
)

export default component.exports